
/**
 * Time units.
 */ var $bfbd47b9658431b4$export$680ea196effce5f;
(function(Time) {
    Time[Time["Second"] = 1000] = "Second";
    Time[Time["Minute"] = 60000] = "Minute";
    Time[Time["Hour"] = 3600000] = "Hour";
})($bfbd47b9658431b4$export$680ea196effce5f || ($bfbd47b9658431b4$export$680ea196effce5f = {}));


class $6e19909b4e3e07aa$export$2c3b404bf3a77a1f {
    /**
   * Canvas element.
   */ canvasElement;
    /**
   * Rendering context.
   */ renderingContext;
    /**
   * Game configuration.
   */ config = {
        /** Simulation configuration. */ simulation: {
            /** Simulation rate, in milliseconds. */ rate: (0, $bfbd47b9658431b4$export$680ea196effce5f).Second / 50
        }
    };
    /**
   * Game statistics.
   */ stats = {
        /** Time of the last game tick. */ time: 0,
        /** Simulation statistics. */ simulation: {
            /** Total simulation steps. */ count: 0,
            /** Time since last step. */ delta: 0,
            /** Time spent in last step. */ duration: 0,
            /** Accumulated time since last fixed step. */ drift: 0
        },
        /** Rendering statistics. */ rendering: {
            /** Total frames rendered. */ count: 0,
            /** Frames per second. */ rate: 0,
            /** Time since last rendered frame. */ delta: 0,
            /** Time spent in last frame. */ duration: 0
        }
    };
    /**
   * Systems attached to the game.
   */ systems = new Map();
    /**
   * State manager.
   */ state;
    /**
   * Input handler.
   */ input;
    /**
   * Game constructor.
   */ constructor(canvasElement){
        this.canvasElement = canvasElement;
        const context = canvasElement.getContext("2d");
        if (!context) throw new Error("Couldn't get rendering context");
        this.renderingContext = context;
        this.input = new (0, $0963a1c22a653bd4$export$2c7a04567169355e)(this);
        this.state = new (0, $fbbd776a8c8e2dde$export$4d5c8163a511d38a)(this);
    }
    /**
   * Add a system to the game.
   */ addSystem(system) {
        this.systems.set(system.constructor, system);
        system.engine = this;
        system.install();
    }
    /**
   * Update game state.
   *
   * @param delta Time since last update, in milliseconds.
   */ update(delta) {
        const now = performance.now();
        this.input.update(delta);
        for (const [, system] of this.systems)system.update(delta);
        this.stats.simulation.count += 1;
        this.stats.simulation.delta = delta;
        this.stats.simulation.duration = performance.now() - now;
    }
    /**
   * Draw a frame.
   *
   * @param delta Time since last update, in milliseconds.
   */ draw(delta) {
        const now = performance.now();
        this.renderingContext.clearRect(0, 0, this.canvasElement.width, this.canvasElement.height);
        for (const system of this.systems.values())system.draw(delta);
        this.stats.rendering.count += 1;
        this.stats.rendering.rate = (0, $bfbd47b9658431b4$export$680ea196effce5f).Second / delta;
        this.stats.rendering.delta = delta;
        this.stats.rendering.duration = performance.now() - now;
    }
    /**
   * Game tick.
   */ tick() {
        const { config: config, stats: stats } = this;
        const time = performance.now();
        const delta = time - this.stats.time;
        stats.time = time;
        // Prevent drift from ballooning.
        stats.simulation.drift += Math.min(delta, (0, $bfbd47b9658431b4$export$680ea196effce5f).Second);
        // Update game state at a fixed rate, accounting for drift, i.e. leftover time between updates.
        while(stats.simulation.drift >= config.simulation.rate){
            stats.simulation.drift -= config.simulation.rate;
            this.update(config.simulation.rate);
        }
        this.draw(delta);
    }
    /**
   * Start the game.
   */ start() {
        const loop = ()=>(this.tick(), requestAnimationFrame(loop));
        loop();
    }
}


class $887690cec81c170d$export$e1dae5660003ffa7 {
    /**
   * A game engine instance.
   */ engine;
    /**
   * Called when the system is installed on the engine.
   */ install() {}
    /**
   * Update the game state.
   * @param delta Time since last update, in milliseconds.
   */ update(delta) {}
    /**
   * Draw a frame.
   * @param delta Time since last draw, in milliseconds.
   */ draw(delta) {}
}


/**
 * Two component vector.
 */ class $feeb6466653dc2d4$export$9b781de7bf37bf48 {
    x = 0;
    y = 0;
    /**
   * Vector constructor.
   */ constructor(x = 0, y){
        if (x instanceof $feeb6466653dc2d4$export$9b781de7bf37bf48) {
            this.x = x.x;
            this.y = x.y;
        } else {
            this.x = x;
            this.y = y ?? x;
        }
    }
    /**
   * Vector magnitude.
   */ get length() {
        const { x: x, y: y } = this;
        return Math.sqrt(x * x + y * y);
    }
    /**
   * String representation, e.g. (x, y).
   */ toString() {
        return `(${this.x.toFixed(2)}, ${this.y.toFixed(2)})`;
    }
    /**
   * Serialize to JSON.
   */ toJSON() {
        return [
            this.x,
            this.y
        ];
    }
    /**
   * Change vector by adding another vector or scalars.
   */ add(x, y) {
        if (x instanceof $feeb6466653dc2d4$export$9b781de7bf37bf48) {
            this.x += x.x;
            this.y += x.y;
        } else {
            this.x += x;
            this.y += y ?? x;
        }
    }
    /**
   * Change vector by subtracting another vector or scalars.
   */ subtract(x, y) {
        if (x instanceof $feeb6466653dc2d4$export$9b781de7bf37bf48) {
            this.x -= x.x;
            this.y -= x.y;
        } else {
            this.x -= x;
            this.y -= y ?? x;
        }
    }
    /**
   * Change vector by multiplying both components by given scalar.
   */ multiply(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    }
    /**
   * Change vector by dividing both components by given scalar.
   */ divide(scalar) {
        this.multiply(1 / scalar);
    }
    /**
   * Get the dot product between two vectors.
   */ dot(vector) {
        return this.x * vector.x + this.y * vector.y;
    }
    /**
   * Get the distance between two vectors.
   */ distance(vector) {
        const distance = new $feeb6466653dc2d4$export$9b781de7bf37bf48(this);
        distance.subtract(vector);
        return distance.length;
    }
    /**
   * Normalize vector to unit length.
   */ normalize() {
        const { length: length } = this;
        if (length !== 0) {
            this.x /= length;
            this.y /= length;
        }
    }
    /**
   * Clamp vector's magnitude.
   */ clamp(max) {
        const { length: length } = this;
        if (length > max) {
            this.normalize();
            this.multiply(max);
        }
    }
    /**
   * Get the opposite vector.
   */ opposite() {
        const opposite = new $feeb6466653dc2d4$export$9b781de7bf37bf48(this);
        opposite.multiply(-1);
        return opposite;
    }
}


/**
 * A component labels an entity as possessing a particular aspect, and holds the data needed to model that aspect.
 * For example, every game object that can take damage might have a Health component associated with its entity.
 */ class $36745d90e2712a53$export$16fa2f45be04daa8 {
    constructor(...args){}
}


/**
 * Unique identifier.
 */ let $40392ed500c02e1d$var$nextId = 1;
function $40392ed500c02e1d$export$7149c6ffc9994c32() {
    return ($40392ed500c02e1d$var$nextId++).toString(36);
}


class $fbbd776a8c8e2dde$export$4d5c8163a511d38a {
    engine;
    data = new Map();
    constructor(engine){
        this.engine = engine;
    }
    /**
   * Add an entity to the game.
   */ addEntity(entity = (0, $40392ed500c02e1d$export$7149c6ffc9994c32)()) {
        this.data.set(entity, new Map());
        return entity;
    }
    /**
   * Remove an entity from the game.
   */ removeEntity(entity) {
        this.data.delete(entity);
    }
    /**
   * Add component to an entity.
   *
   * @param entity The entity.
   * @param components The component.
   */ addComponent(entity, ...components) {
        const data = this.data.get(entity);
        if (!data) throw new Error(`Entity ${entity} not found`);
        for (const component of components)data.set(component.constructor, component);
    }
    /**
   * Remove component from an entity.
   *
   * @param entity The entity.
   */ removeComponent(entity, ...components) {
        const data = this.data.get(entity);
        if (!data) throw new Error(`Entity ${entity} not found`);
        for (const component of components)data.delete(component);
    }
    /**
   * Get component data for an entity.
   *
   * @param entity The entity.
   * @param component Component type.
   */ get(entity, component) {
        const data = this.data.get(entity);
        if (!data) throw new Error(`Entity ${entity} not found`);
        return data.get(component);
    }
    /**
   * Find one or more entities by their components.
   *
   * @param components List of components to match.
   */ query(...components) {
        const result = [];
        loop: for (const [entity, data] of this.data){
            for (const component of components){
                if (!data.has(component)) continue loop;
            }
            result.push(entity);
        }
        return result;
    }
}



class $0963a1c22a653bd4$export$2c7a04567169355e {
    /**
   * Game engine instance.
   */ engine;
    /**
   * Input queues.
   */ queue = {
        fresh: new Set(),
        stale: new Set()
    };
    /**
   * Input state.
   */ state = new Map();
    /**
   * Cursor coordinates.
   */ coordinates = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(0);
    /**
   * Input handler constructor.
   */ constructor(engine){
        this.engine = engine;
        engine.canvasElement.addEventListener("keydown", (e)=>{
            e.preventDefault();
            // Prevent duplicate keydown events.
            if (e.repeat) return;
            this.queue.fresh.add({
                key: e.code,
                time: engine.stats.time,
                duration: 0,
                coordinates: new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(0),
                fresh: true,
                stale: false
            });
        });
        engine.canvasElement.addEventListener("mousedown", (e)=>{
            this.queue.fresh.add({
                key: `Mouse${e.button}`,
                time: engine.stats.time,
                duration: 0,
                coordinates: new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(e.offsetX, e.offsetY),
                fresh: true,
                stale: false
            });
        });
        engine.canvasElement.addEventListener("mousemove", (e)=>{
            this.coordinates.x = e.offsetX;
            this.coordinates.y = e.offsetY;
        });
        // Listen on window to finish input state even if the canvas loses focus.
        window.addEventListener("keyup", (e)=>{
            this.queue.stale.add(e.code);
        });
        window.addEventListener("mouseup", (e)=>{
            this.queue.stale.add(`Mouse${e.button}`);
        });
        // Prevent the context menu on right-click.
        engine.canvasElement.addEventListener("contextmenu", (e)=>{
            e.preventDefault();
        });
    }
    isFresh(key) {
        return this.state.get(key)?.fresh ?? false;
    }
    isStale(key) {
        return this.state.get(key)?.stale ?? false;
    }
    isPressed(key) {
        return this.state.has(key);
    }
    get(key) {
        return this.state.get(key);
    }
    update(delta) {
        const marked = new Set();
        for (const [, input] of this.state){
            input.duration += delta;
            input.fresh = false;
            if (input.stale) marked.add(input.key);
        }
        for (const key of marked)this.state.delete(key);
        for (const key of this.queue.stale){
            const input = this.state.get(key);
            if (input) input.stale = true;
        }
        this.queue.stale.clear();
        for (const input of this.queue.fresh)this.state.set(input.key, input);
        this.queue.fresh.clear();
    }
}






class $d45fe85cf57055d5$export$4142ddaf5291caee extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
    active = true;
}



class $51ea1fd00b713086$export$713b5f826568841e extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
}



class $e818ddf1dd0049d7$export$4d8a2dd92b1567c6 extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
}



class $63fc19db3ed0c854$export$3ddcd94b699ad478 extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
    position = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)();
    size = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(10, 10);
    direction = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)();
    velocity = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)();
    acceleration = 100;
    mass = 10;
    constructor(data){
        super();
        Object.assign(this, data);
    }
}


class $65867fe38d8fbe57$export$7a7fa4424cb20976 extends (0, $887690cec81c170d$export$e1dae5660003ffa7) {
    update() {
        const entities = this.engine.state.query((0, $d45fe85cf57055d5$export$4142ddaf5291caee), (0, $51ea1fd00b713086$export$713b5f826568841e), (0, $e818ddf1dd0049d7$export$4d8a2dd92b1567c6));
        for (const entity of entities){
            const physical = this.engine.state.get(entity, (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
            if (this.engine.input.isPressed("Mouse0")) {
                physical.direction = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(this.engine.input.coordinates);
                physical.direction.subtract(physical.position);
            } else {
                physical.direction = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(0, 0);
                if (this.engine.input.isPressed("ArrowLeft")) physical.direction.x -= 1;
                if (this.engine.input.isPressed("ArrowRight")) physical.direction.x += 1;
                if (this.engine.input.isPressed("ArrowUp")) physical.direction.y -= 1;
                if (this.engine.input.isPressed("ArrowDown")) physical.direction.y += 1;
            }
            physical.direction.normalize();
            const force = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(physical.direction);
            force.multiply(physical.acceleration);
            physical.velocity.add(force);
        }
    }
}







class $a3156871e02c6fd2$export$2f09efa5b67124a7 extends (0, $887690cec81c170d$export$e1dae5660003ffa7) {
    update(delta) {
        const entities = this.engine.state.query((0, $d45fe85cf57055d5$export$4142ddaf5291caee), (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
        for(let indexA = 0; indexA < entities.length; indexA++){
            const entityA = entities[indexA];
            const dataA = this.engine.state.get(entityA, (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
            for(let indexB = indexA + 1; indexB < entities.length; indexB++){
                const entityB = entities[indexB];
                const dataB = this.engine.state.get(entityB, (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
                if (!this.isColliding(dataA, dataB)) continue;
                const centerA = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(dataA.position);
                centerA.add(dataA.size.x / 2, dataA.size.y / 2);
                const centerB = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(dataB.position);
                centerB.add(dataB.size.x / 2, dataB.size.y / 2);
                const collision = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(centerA);
                collision.subtract(centerB);
                collision.normalize();
                const velocityDiff = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(dataA.velocity);
                velocityDiff.subtract(dataB.velocity);
                const relativeVelocity = collision.dot(velocityDiff);
                const impulse = 2 * relativeVelocity / (dataA.mass + dataB.mass);
                const forceA = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(collision);
                forceA.multiply(impulse * dataB.mass);
                dataA.velocity.subtract(forceA);
                const forceB = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(collision);
                forceB.multiply(impulse * dataA.mass);
                dataB.velocity.add(forceB);
            }
            dataA.velocity.divide(1 + dataA.mass / 1000);
            dataA.velocity.clamp(1000);
            if (this.engine.state.get(entityA, (0, $e818ddf1dd0049d7$export$4d8a2dd92b1567c6))) {
                const v = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(dataA.velocity);
                v.multiply(delta / (0, $bfbd47b9658431b4$export$680ea196effce5f).Second);
                dataA.position.add(v);
            }
        }
    }
    isColliding(a, b) {
        const al = a.position.x;
        const ar = a.position.x + a.size.x;
        const at = a.position.y;
        const ab = a.position.y + a.size.y;
        const bl = b.position.x;
        const br = b.position.x + b.size.x;
        const bt = b.position.y;
        const bb = b.position.y + b.size.y;
        if (ar < bl || al > br) return false;
        if (ab < bt || at > bb) return false;
        return true;
    }
}






class $f153cc92129aaea3$export$ba38c447f3562aeb extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
    color = "fuchsia";
    constructor(data){
        super();
        Object.assign(this, data);
    }
}


class $87a1304e7ae5cf90$export$160ae30d75f98247 extends (0, $887690cec81c170d$export$e1dae5660003ffa7) {
    draw() {
        const entities = this.engine.state.query((0, $d45fe85cf57055d5$export$4142ddaf5291caee), (0, $63fc19db3ed0c854$export$3ddcd94b699ad478), (0, $f153cc92129aaea3$export$ba38c447f3562aeb));
        for (const entity of entities){
            const renderable = this.engine.state.get(entity, (0, $f153cc92129aaea3$export$ba38c447f3562aeb));
            const physical = this.engine.state.get(entity, (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
            this.engine.renderingContext.fillStyle = renderable.color;
            this.engine.renderingContext.beginPath();
            this.engine.renderingContext.rect(Math.round(physical.position.x), Math.round(physical.position.y), physical.size.x, physical.size.y);
            this.engine.renderingContext.fill();
            this.engine.renderingContext.closePath();
        }
    }
}










function $ae31c950a73b8f16$var$format(label, value) {
    if (typeof value === "number") value = value.toFixed(2).padStart(10);
    return `${label.padEnd(10)}${value}`;
}
class $ae31c950a73b8f16$export$2d0294657ab35f1b extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
    text = [];
    position = new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)();
    enabled = false;
    constructor(data){
        super();
        Object.assign(this, data);
    }
}
class $ae31c950a73b8f16$export$153e5dc2c098b35c extends (0, $887690cec81c170d$export$e1dae5660003ffa7) {
    checkpoint = 0;
    entity = "debug";
    install() {
        this.checkpoint = this.engine.stats.time;
        this.engine.state.addEntity(this.entity);
        this.engine.state.addComponent(this.entity, new $ae31c950a73b8f16$export$2d0294657ab35f1b());
    }
    update() {
        const delta = this.engine.stats.time - this.checkpoint;
        const data = this.engine.state.get(this.entity, $ae31c950a73b8f16$export$2d0294657ab35f1b);
        if (this.engine.input.get("KeyD")?.fresh) data.enabled = !data.enabled;
        if (!data.enabled) return;
        // Update keys in real time.
        if (data.text.length > 0) data.text[12] = $ae31c950a73b8f16$var$format("Keys", Array.from(this.engine.input.state.keys()).toString());
        if (delta < 300) return;
        data.text = [];
        data.text.push("--Rendering".padEnd(20, "-"));
        data.text.push($ae31c950a73b8f16$var$format("Count", this.engine.stats.rendering.count));
        data.text.push($ae31c950a73b8f16$var$format("Rate", this.engine.stats.rendering.rate));
        data.text.push($ae31c950a73b8f16$var$format("Delta", this.engine.stats.rendering.delta));
        data.text.push($ae31c950a73b8f16$var$format("Duration", this.engine.stats.rendering.duration));
        data.text.push("--Simulation".padEnd(20, "-"));
        data.text.push($ae31c950a73b8f16$var$format("Steps", this.engine.stats.simulation.count));
        data.text.push($ae31c950a73b8f16$var$format("Rate", (0, $bfbd47b9658431b4$export$680ea196effce5f).Second / this.engine.config.simulation.rate));
        data.text.push($ae31c950a73b8f16$var$format("Delta", this.engine.stats.simulation.delta));
        data.text.push($ae31c950a73b8f16$var$format("Duration", this.engine.stats.simulation.duration));
        data.text.push($ae31c950a73b8f16$var$format("Drift", this.engine.stats.simulation.drift));
        data.text.push("--Input".padEnd(20, "-"));
        data.text.push($ae31c950a73b8f16$var$format("Keys", Array.from(this.engine.input.state.keys()).toString()));
        this.checkpoint = this.engine.stats.time;
    }
    draw() {
        const data = this.engine.state.get(this.entity, $ae31c950a73b8f16$export$2d0294657ab35f1b);
        if (!data.enabled) return;
        this.engine.renderingContext.fillStyle = "rgba(255, 255, 255, 0.9)";
        this.engine.renderingContext.fillRect(data.position.x, data.position.y, 135, data.text.length * 14);
        this.engine.renderingContext.fillStyle = "blue";
        this.engine.renderingContext.font = "bold 12px monospace";
        this.engine.renderingContext.textBaseline = "top";
        for(let i = 0; i < data.text.length; i++)this.engine.renderingContext.fillText(data.text[i], data.position.x, data.position.y + i * 14);
        const entities = this.engine.state.query((0, $d45fe85cf57055d5$export$4142ddaf5291caee), (0, $63fc19db3ed0c854$export$3ddcd94b699ad478), (0, $f153cc92129aaea3$export$ba38c447f3562aeb));
        for (const entity of entities){
            const physical = this.engine.state.get(entity, (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
            // Draw an arrow to show velocity
            this.engine.renderingContext.strokeStyle = "green";
            this.engine.renderingContext.beginPath();
            this.engine.renderingContext.moveTo(physical.position.x + physical.size.x / 2, physical.position.y + physical.size.y / 2);
            this.engine.renderingContext.lineTo(physical.position.x + physical.size.x / 2 + physical.velocity.x / 10, physical.position.y + physical.size.y / 2 + physical.velocity.y / 10);
            this.engine.renderingContext.stroke();
            this.engine.renderingContext.closePath();
            const text = physical.velocity.length.toFixed(2);
            const textInfo = this.engine.renderingContext.measureText(text);
            this.engine.renderingContext.fillStyle = "green";
            this.engine.renderingContext.font = "12px monospace";
            this.engine.renderingContext.fillText(text, physical.position.x - textInfo.width, physical.position.y + -10);
        }
    }
}





const $0f592d681121713f$var$canvasElement = document.querySelector("canvas");
if (!$0f592d681121713f$var$canvasElement) throw new Error("No <canvas> found");
$0f592d681121713f$var$canvasElement.width = window.innerWidth * 0.9;
$0f592d681121713f$var$canvasElement.height = window.innerHeight * 0.9;
const $0f592d681121713f$var$game = new (0, $6e19909b4e3e07aa$export$2c3b404bf3a77a1f)($0f592d681121713f$var$canvasElement);
$0f592d681121713f$var$game.config.simulation.rate = (0, $bfbd47b9658431b4$export$680ea196effce5f).Second / 50;
$0f592d681121713f$var$game.start();
class $0f592d681121713f$var$BoxComponent extends (0, $36745d90e2712a53$export$16fa2f45be04daa8) {
}
class $0f592d681121713f$var$CustomSystem extends (0, $887690cec81c170d$export$e1dae5660003ffa7) {
    update(delta) {
        if (this.engine.input.get("Enter")?.fresh) this.spawnMoreBoxes();
        if (this.engine.input.get("Backspace")?.fresh) this.deleteBoxes();
        const player = this.engine.state.query((0, $51ea1fd00b713086$export$713b5f826568841e));
        const physicalData = this.engine.state.get(player[0], (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
        const space = this.engine.input.get("Space");
        if (space?.fresh) {
            physicalData.mass = physicalData.mass === 100 ? 2000 : 100;
            physicalData.acceleration = physicalData.mass * 2;
        }
        const boxes = this.engine.state.query($0f592d681121713f$var$BoxComponent);
        for(let i = 0; i < boxes.length; i++){
            const box = boxes[i];
            const physicalData = this.engine.state.get(box, (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
            if (physicalData.position.x + physicalData.size.x < 0 || physicalData.position.x > this.engine.canvasElement.width) this.engine.state.removeEntity(box);
            if (physicalData.position.y + physicalData.size.y < 0 || physicalData.position.y > this.engine.canvasElement.height) this.engine.state.removeEntity(box);
        }
    }
    draw() {
        const boxes = this.engine.state.query($0f592d681121713f$var$BoxComponent);
        const player = this.engine.state.query((0, $51ea1fd00b713086$export$713b5f826568841e));
        const playerPhysical = this.engine.state.get(player[0], (0, $63fc19db3ed0c854$export$3ddcd94b699ad478));
        this.engine.renderingContext.textBaseline = "top";
        this.engine.renderingContext.font = "bold 14px monospace";
        this.engine.renderingContext.fillStyle = "red";
        this.engine.renderingContext.strokeStyle = "white";
        this.engine.renderingContext.lineWidth = 1;
        const text = `BOXES [enter/backspace]: ${boxes.length}     PLAYER MASS [space]: ${playerPhysical.mass}     DEBUG [d]`;
        this.engine.renderingContext.fillText(text, this.engine.canvasElement.width / 2 - this.engine.renderingContext.measureText(text).width / 2, 10);
    }
    deleteBoxes() {
        const boxes = this.engine.state.query($0f592d681121713f$var$BoxComponent);
        for(let i = 0; i < 100; i++)this.engine.state.removeEntity(boxes[i]);
    }
    spawnMoreBoxes() {
        for(let i = 0; i < 100; i++){
            const box = $0f592d681121713f$var$game.state.addEntity();
            $0f592d681121713f$var$game.state.addComponent(box, new $0f592d681121713f$var$BoxComponent());
            $0f592d681121713f$var$game.state.addComponent(box, new (0, $d45fe85cf57055d5$export$4142ddaf5291caee)());
            $0f592d681121713f$var$game.state.addComponent(box, new (0, $e818ddf1dd0049d7$export$4d8a2dd92b1567c6)());
            $0f592d681121713f$var$game.state.addComponent(box, new (0, $63fc19db3ed0c854$export$3ddcd94b699ad478)({
                position: new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)($0f592d681121713f$var$game.canvasElement.width * Math.random(), $0f592d681121713f$var$game.canvasElement.height * Math.random()),
                size: new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(5, 5),
                mass: 50
            }));
            $0f592d681121713f$var$game.state.addComponent(box, new (0, $f153cc92129aaea3$export$ba38c447f3562aeb)({
                color: "black"
            }));
        }
    }
}
$0f592d681121713f$var$game.addSystem(new (0, $65867fe38d8fbe57$export$7a7fa4424cb20976)());
$0f592d681121713f$var$game.addSystem(new (0, $a3156871e02c6fd2$export$2f09efa5b67124a7)());
$0f592d681121713f$var$game.addSystem(new (0, $87a1304e7ae5cf90$export$160ae30d75f98247)());
$0f592d681121713f$var$game.addSystem(new $0f592d681121713f$var$CustomSystem());
$0f592d681121713f$var$game.addSystem(new $ae31c950a73b8f16$export$153e5dc2c098b35c());
const $0f592d681121713f$var$player = $0f592d681121713f$var$game.state.addEntity();
$0f592d681121713f$var$game.state.addComponent($0f592d681121713f$var$player, new (0, $d45fe85cf57055d5$export$4142ddaf5291caee)());
$0f592d681121713f$var$game.state.addComponent($0f592d681121713f$var$player, new (0, $e818ddf1dd0049d7$export$4d8a2dd92b1567c6)());
$0f592d681121713f$var$game.state.addComponent($0f592d681121713f$var$player, new (0, $63fc19db3ed0c854$export$3ddcd94b699ad478)({
    position: new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)($0f592d681121713f$var$game.canvasElement.width / 2, $0f592d681121713f$var$game.canvasElement.height / 2),
    size: new (0, $feeb6466653dc2d4$export$9b781de7bf37bf48)(20),
    mass: 100,
    acceleration: 200
}));
$0f592d681121713f$var$game.state.addComponent($0f592d681121713f$var$player, new (0, $f153cc92129aaea3$export$ba38c447f3562aeb)());
$0f592d681121713f$var$game.state.addComponent($0f592d681121713f$var$player, new (0, $51ea1fd00b713086$export$713b5f826568841e)());


//# sourceMappingURL=index.c43ce943.js.map
